import React, { useEffect, useState } from 'react'
import './Heading.scss'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

// function Heading({headingName,hideHeader,backTo}) {
function Heading({headingData}) {
  const history = useHistory()

  const device = localStorage.getItem('device');
  return (
    <div className='Heading'>
        {/* {device && headingData.isHideHeader ?null: */}
        {/* <h4 className={headingData.className}> */}
        <h4 className={`${headingData.className} ${device === 'true' && window.innerWidth <= 912 ? "HIDE_IN_MOBILE" : ""}`}>

          {window.innerWidth <= 912 && headingData.backLink ?
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              onClick={() => {
                if (headingData.backLink == 'back') {
                  history.goBack();
                } else {
                  history.push(headingData.backLink);
                }
              }}>
              <g clip-path="url(#clip0_1_23835)">
                <path d="M17.5098 3.86961L15.7298 2.09961L5.83984 11.9996L15.7398 21.8996L17.5098 20.1296L9.37984 11.9996L17.5098 3.86961Z" fill="#1C304A" fill-opacity="0.52" />
              </g>
              <defs>
                <clipPath id="clip0_1_23835">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            :''}
          {headingData.title}
        </h4>
        {/* } */}
    </div>
  )
}

export default Heading